/**
 * tdw local 上报
 * @author riverhan
 * @date 2016-11-15
 */

import tdw from './tdw'; // tdw上报core模块
import util from '../lib/util'; // tdw上报core模块
import localData from '@tencent/im-local.data/local.data'; // 封装好的localStorage
import getPowerLocal from '@tencent/im-local.data/power.local'; // 支持跨域的local生成函数

var powerLocal = {}; // 支持跨域的local
var localReport = {}; // local tdw上报对象
var LOCAL_AVAILABLE = _isLocalAvailable(); // 当前浏览器Localstorage是否可用
var _opts = {
  whiteDomain: [], // 域名白名单，不在此列表中的表示跨域
  crossProxy: '', // 跨域local操作时使用的代理iframe地址
  crossDomain: false, // 是否开启跨域local操作，仅为true时，上面两个参数才有效果
  localPrefix: 'ntdw_seq', // local中存储上报数据的Key前缀
  seqName: 'seq_number', // 一条上报数据的唯一标记，会上报到后台表中，统计PV时要根据这个去重
};
var seqFilterReg = /^tdw_seq/;
var canRetry = true; // 默认是可以从 local 中取出数据重试的，但如果有接口上报失败，则此次不做重试
var isLocalInit = false;

// 有些方法直接使用tdw的
localReport.composer = tdw.composer;
localReport.getCommonData = tdw.getCommonData;
localReport.config = tdw.config;
localReport.request = tdw.request;

localReport.config(
  {},
  {
    success: _reportSuccess,
    error: _reportFail,
    fail: _reportFail,
  }
);

/**
 * 上报成功回调，主要用于删除Local中已经成功上报的数据
 * @param  {Object} response     上报请求返回
 * @param  {Object} fieldAndData 上报的数据
 */
function _reportSuccess(response, fieldAndData) {
  if (!powerLocal.wasInit || !powerLocal.wasInit()) { // local还没有ready,直接返回
    return;
  }

  var fields = fieldAndData.fields;
  var datas = fieldAndData.datas;
  var keyIndex = fields.indexOf(_opts.seqName);

  util.each(datas, function (i, data) { // 删除上报成功的数据对应的local
    var localId = _opts.localPrefix + data[keyIndex];

    powerLocal.remove(localId);
  });
}

function _reportFail() {
  canRetry = false;
}
/**
 * 对一个或者一批数据进行操作
 * @param  {Object | Array}   data 要操作的数据，可以是一个对象，或者对象数组
 * @param  {Function} cb   要对数据进行的操作
 */
function _oneOrAll(data, cb) {
  if (util.isPlainObject(data)) { // 单条数据
    cb && cb(data);
  } else if (Array.isArray(data)) { // 多条数据
    util.each(data, function (i, item) {
      cb && cb(item);
    });
  }
}

/**
 * 生成随机seq串
 * @return {String} 随机seq串
 */
function _getSeq() {
  return (
    new Date().getTime() +
    Math.random()
      .toFixed(17)
      .toString()
      .replace('.', '')
  );
}

function getParseData(v) {
  var parseData;
  try {
    if (v) {
      parseData = JSON.parse(v);
    }
  } catch (e) {
    // console.error(e);
  }
  return parseData || {};
}
/**
 * 检测Local中有无其它页面残留的local上报
 */
function _checkInitLocal() {
  if (!canRetry || window.location.pathname === '/storage_proxy.html') {
    return;
  }
  powerLocal.filter(seqFilterReg, function (locals) {
    var data;
    locals = locals.slice(0, 4); // 如果失败太多，一次也就重试 4 条记录
    for (var i = 0; i < locals.length; i++) {
      data = getParseData(locals[i].value || '{}');

      if (!data.seq_number) { // 老版local方案的残留数据，格式不兼容，直接在Local中删掉
        powerLocal.remove(locals[i].key);
      } else {
        data.datas && data.datas[0].push('local');
        data.fields && data.fields.push('source_from');

        localReport.request(data);
      }
    }
  });
}

/**
 * 初始化localData,并处检测之前页面没有上报的数据
 */
function _initLocal() {
  getPowerLocal.getLocal(
    {
      whiteDomain: _opts.whiteDomain,
      iframeUrl: _opts.crossProxy,
      crossDomain: _opts.crossDomain
    },
    function (local) {
      powerLocal = local;
      setTimeout(function () {
        _checkInitLocal();
      }, 1000);
    }
  );
}

/**
 * 为要上报的数据增加一些字段，实现local上报过程中需要用到
 * @param  {Object | Array} data 要上报的数据，一条或者多条
 */
function _enhanceData(data) {
  _oneOrAll(data, function (item) {
    // 用于标记唯一一条上报,会报到数据表中。在统计PV时需要根据这个字段去重
    // 同时，这个也用于和local前缀一起，组成上报记录在local中存储的key值
    item[_opts.seqName] = _getSeq();
  });
}

/**
 * 检测local是否可用
 */
function _isLocalAvailable() {
  return localData && localData.obj && localData.obj() !== null;
}

/**
 * 将原始的对象/数组数据，转化成要保存到Local中的数组数据
 * @param  {Object | Array} data       要转化的数据
 * @param  {Array} dataToSave 转化后的数据
 */
function _mapDataToSave(data, dataToSave) {
  _oneOrAll(data, function (item) {
    dataToSave.push(
      Object.assign(
        {
          seq_number: item[_opts.seqName], // 这个seq_number用于保存local时便捷确定local的key值
        },
        localReport.composer(item)
      )
    );
  });
}

/**
 * 将数据保存到local中
 * 每条上报数据存一个local的key-value
 * @param  {Array} dataToSave  要保存的数据数组
 */
function _saveLocal(dataToSave) {
  if (!powerLocal.wasInit || !powerLocal.wasInit()) { // local还没有ready,直接返回
    return;
  }

  util.each(dataToSave, function (i, item) {
    var localId = _opts.localPrefix + item[_opts.seqName];

    powerLocal.set(localId, JSON.stringify(item));
  });
}

/**
 * 处理要上报的数据
 * 主要是扩展一些控制字段，以及存储到local中
 * @param  {Object | Array} data 要上报的数据
 */
function _handleLocalData(data) {
  var dataToSave = [];

  _enhanceData(data); // 增加一些控制字段
  _mapDataToSave(data, dataToSave); // 将原始数据转化为要存到local中的数据
  _saveLocal(dataToSave); // 将组合好的数据保存到local中
}

localReport.report = function (data) {
  _handleLocalData(data);
  tdw.report(data); // 调用core的上报
};

localReport.reportSync = function (data, config) {
  _handleLocalData(data);
  tdw.reportSync(data, config);
};

/**
 * 初始化Local设置
 * 在上报前必须先执行一下这个函数，用于确定是同域local还是跨域local
 * 一旦初始化local完成，不可再对Local的设置进行变更
 * @param  {Object} opts local相关设置
 */
localReport.initLocal = function (opts) {
  Object.assign(_opts, opts);

  seqFilterReg = new RegExp('^' + _opts.localPrefix);

  // 支持localstorage，就初始化local操作库
  if (LOCAL_AVAILABLE && !isLocalInit) {
    isLocalInit = true;
    _initLocal();
  }
};

export default localReport;
